import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id A301F5C0-B760-4EA0-B803-DEF84D1B01CD
 * name not-equal
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/not-equal.svg
 * tags
 */
export const NotEqualIcon = createSvgIcon(<><path d="M21,10H9V8H21V10M21,16H9V14H21V16M4,5H6V16H4V5M6,18V20H4V18H6Z" /></>, 'NotEqualIcon');
export default NotEqualIcon